import { useMutation, useQuery } from '@tanstack/react-query';
import { settingsService, type UserSettings } from '../services/settings.service';
import toast from 'react-hot-toast';

export const useBackendSettings = () => {
  // Fetch user settings
  const { data: settings = {}, isLoading: isFetching, refetch } = useQuery({
    queryKey: ['user-backend-settings'],
    queryFn: () => settingsService.getSettings(),
    retry: 1,
  });

  // Save settings mutation
  const { mutate: saveSettings, isPending: isSaving } = useMutation({
    mutationFn: (newSettings: Partial<UserSettings>) => {
      console.log('useBackendSettings: Saving settings:', newSettings);
      return settingsService.saveSettings(newSettings);
    },
    onSuccess: () => {
      console.log('useBackendSettings: Settings saved successfully');
      toast.success('Settings saved');
      refetch();
    },
    onError: (error: any) => {
      console.error('useBackendSettings: Error saving settings:', error);
      toast.error(error?.response?.data?.message || 'Failed to save settings');
    },
  });

  return {
    settings,
    isLoading: isFetching,
    isUpdating: isSaving,
    saveSettings,
    refetch,
  };
};
